import { render, staticRenderFns } from "./WatchersCard.vue?vue&type=template&id=4f3a1aa8"
import script from "./WatchersCard.vue?vue&type=script&lang=js"
export * from "./WatchersCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports